import PropTypes from "prop-types";
import React from "react";

import css from "./roles_demand_preview.module.scss";
import TilePreview from "./tile_preview";

const RolesDemandPreview = ({ content }) => (
  <div>
    <div className={css.rolesDemandFirstRow}>
      <TilePreview loading={!content} content={content} />
      <TilePreview loading={!content} content={content} />
      <TilePreview loading={!content} content={content} />
    </div>
    <div className={css.rolesDemandSecondRow}>
      <TilePreview loading={!content} content={content} />
      <TilePreview loading={!content} content={content} />
      <TilePreview loading={!content} content={content} />
    </div>
  </div>
);

RolesDemandPreview.propTypes = {
  content: PropTypes.string
};

export default RolesDemandPreview;
